import styled from 'styled-components';

export const IndividualActiveContactZone = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem;
  margin-bottom: 0.1rem;
`;

export const LabelTitle = styled.h6`
  font-size: 1rem;
  margin-bottom: 0;
`;

export const ActionsChatZone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 2px;
`;
